/**
 * WhatsApp Widget Position Adjuster
 * Dynamically adjusts external WhatsApp widget position above sticky add to cart
 */

(function() {
  'use strict';

  // Function to find and adjust WhatsApp widgets
  function adjustWhatsAppWidgets() {
    // Common selectors for WhatsApp widgets
    const selectors = [
      // Generic selectors
      '[class*="whatsapp"][class*="widget"]',
      '[class*="whatsapp"][class*="float"]',
      '[class*="whatsapp"][class*="chat"]',
      '[id*="whatsapp-widget"]',
      '[id*="whatsapp-chat"]',
      '[id*="wa-widget"]',
      '[id*="wa-chat"]',
      '.whatsapp-widget',
      '.whatsapp-float',
      '.whatsapp-chat-widget',
      '.wa-widget',
      '.wa-chat-widget',
      // Third-party apps
      '.elfsight-app-whatsapp',
      '[class*="elfsight"][class*="whatsapp"]',
      '#tidio-chat',
      '#tidio-chat-iframe',
      '#tawk-bubble-container',
      '.tawk-button',
      '.wa-widget-send-button',
      '.wa__btn_popup',
      '.superlemon-whatsapp-widget'
    ];

    // Check if we're on a product page
    const isProductPage = document.body.className.includes('template-product');
    
    // Check each selector
    selectors.forEach(selector => {
      try {
        const elements = document.querySelectorAll(selector);
        elements.forEach(element => {
          if (element && window.getComputedStyle(element).position === 'fixed') {
            // Check if on mobile
            const isMobile = window.innerWidth < 750;
            
            if (isProductPage && isMobile) {
              // On product pages, move above sticky ATC on mobile
              element.style.setProperty('bottom', '90px', 'important');
              element.style.setProperty('z-index', '9997', 'important');
            } else {
              // On all other pages or desktop, keep lower
              element.style.setProperty('bottom', '20px', 'important');
              element.style.setProperty('z-index', '9997', 'important');
            }
          }
        });
      } catch (e) {
        // Selector might not be valid, skip
      }
    });
  }

  // Run on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', adjustWhatsAppWidgets);
  } else {
    adjustWhatsAppWidgets();
  }

  // Watch for new elements being added (for lazy-loaded widgets)
  const observer = new MutationObserver((mutations) => {
    let shouldAdjust = false;
    
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) { // Element node
            const nodeName = node.className ? node.className.toLowerCase() : '';
            const nodeId = node.id ? node.id.toLowerCase() : '';
            
            if (nodeName.includes('whatsapp') || 
                nodeName.includes('wa-') || 
                nodeName.includes('chat') ||
                nodeName.includes('widget') ||
                nodeId.includes('whatsapp') || 
                nodeId.includes('wa-') ||
                nodeId.includes('chat') ||
                nodeId.includes('tidio') ||
                nodeId.includes('tawk')) {
              shouldAdjust = true;
            }
          }
        });
      }
    });
    
    if (shouldAdjust) {
      setTimeout(adjustWhatsAppWidgets, 100);
    }
  });

  // Start observing
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Re-adjust on window resize
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(adjustWhatsAppWidgets, 250);
  });

  // Re-adjust when sticky button visibility changes
  const stickyButton = document.getElementById('sticky-atc-trigger');
  if (stickyButton) {
    const buttonObserver = new MutationObserver(() => {
      adjustWhatsAppWidgets();
    });
    
    buttonObserver.observe(stickyButton, {
      attributes: true,
      attributeFilter: ['class', 'style']
    });
  }

  // Check periodically for the first 10 seconds (for very slow-loading widgets)
  let checkCount = 0;
  const checkInterval = setInterval(() => {
    adjustWhatsAppWidgets();
    checkCount++;
    
    if (checkCount >= 20) { // 20 checks * 500ms = 10 seconds
      clearInterval(checkInterval);
    }
  }, 500);

})();


